import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditDescription } from '../../../actions/studio';
import { Props } from './DescriptionBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditDescription'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  batchEditDescription: desc => dispatch(batchEditDescription(desc)),
});

export default connect(null, mapDispatchToProps);
